import { PlayIcon } from '@heroicons/react/24/outline';
import ButtonComponent from '../customButton';
import { LAUNCH_NUDGE_CONTENT } from './testGroupDetailOverview.constants';
import styles from '../../styles/testGroupDetail/launchNudgeBanner.module.scss';

export default function TestGroupLaunchNudgeBanner({ caseCount, onCreateLaunch }) {
  return (
    <div className={styles.banner} role="status">
      <div className={styles.content}>
        <p className={styles.title}>{LAUNCH_NUDGE_CONTENT.title}</p>
        <p className={styles.description}>
          {LAUNCH_NUDGE_CONTENT.getDescription(caseCount)}
        </p>
      </div>
      <ButtonComponent
        ctaText={LAUNCH_NUDGE_CONTENT.ctaLabel}
        variant="primary"
        startIcon={<PlayIcon className="icon" />}
        onClick={onCreateLaunch}
        className={`white bg-blue600 ${styles.cta}`}
        size="small"
      />
    </div>
  );
}
